<template>
    <div>
        <loader v-if="mediaLoading"/>
        <div v-for="mediaType in docMediaTypes" class="form-group">
            <label class="col-md-2 control-label text-label">{{mediaType.name}}</label>
            <div class="col-md-10">
                <table v-show="mediaList.find(x=> {return x.mediaTypeId === mediaType.mediaTypeId})" class="table">
                    <thead>
                        <tr>
                            <th style="width:10%">Download</th>
                            <th style="width:30%">File Name</th>
                            <th style="width:30%">Comment</th>
                            <th style="width:20%">Uploaded By</th>
                            <th style="width:10%">Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="mediaItem in mediaList.filter(m => {return m.mediaTypeId === mediaType.mediaTypeId})">
                            <td>
                                <div style="text-align: center;">
                                    <a class="fa fa-cloud-download" style="font-size: 18px;" target="_blank" v-on:click="mediaDownloadRow(mediaItem.mediaId, mediaItem.mediaTypeId, mediaType.mediaSubtype, mediaItem.parentId, mediaItem.filename)"></a>
                                </div>
                            </td>
                            <td>{{mediaItem.filename}}</td>
                            <td>{{mediaItem.comment}}</td>
                            <td>{{mediaItem.createdBy}}</td>
                            <td>
                                <div style="text-align: center;">
                                    <a class="fa fa-ban" style="font-size: 18px;" target="_blank" v-on:click="mediaRemove(mediaItem.mediaId)"></a>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div v-show="!(mediaList.find(x=> {return x.mediaTypeId === mediaType.mediaTypeId}))">
                    <label>No matching records</label>
                </div>
            </div>
        </div>

        <div class="form-group">
            <label class="col-md-2">Add File</label>
            <div class="col-md-10">
                <form v-on:submit.prevent class="form" id="documentForm" data-vv-scope="mediaFile">
                    <div class="row">
                        <div class="col-md-2">
                            <div class="form-group" v-bind:class="{ 'has-error': errors.has('mediaFile.mediaType') }">
                                <label>Type</label>
                                <select name="mediaType" class="form-control" v-model="mediaTypeId" v-validate="'required'" data-vv-validate-on="none">
                                    <option disabled value=''>Select a value</option>
                                    <option v-for="mediaType in docMediaTypes" v-bind:value="mediaType.mediaTypeId">
                                        {{mediaType.name}}
                                    </option>
                                </select>
                                <div><span v-show="errors.has('mediaFile.mediaType')" class="has-error">Media type is required</span></div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group" v-bind:class="{ 'has-error': errors.has('mediaFile.newFile') }">
                                <label>File</label><br>
                                <input name="newFile" ref="newFile" class="file" type="file" v-validate="'required'" data-vv-validate-on="none">
                                <div><span v-show="errors.has('mediaFile.newFile')" class="has-error">File is required</span></div>
                            </div>
                        </div>
                        <div class="col-md-5">
                            <div class="form-group">
                                <label>Comment</label>
                                <input type="text" class="form-control" v-model="comment">
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-3"></div>
                        <div class="col-md-8">
                            <div v-show="errors.any('mediaFile')">
                                <span class="has-error">Validation issues must be corrected prior to upload</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-3"></div>
                        <div class="col-md-8">
                            <div v-show="serverErrorList.length > 0">
                                <span class="has-error">Validation issues must be corrected prior to submit</span>
                                <ul class="has-error">
                                    <li v-for="serverError in serverErrorList" :key="serverError">{{ serverError }}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <button class="btn btn-primary col-md-1" v-on:click="addFile">Upload</button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import mediaService from '@/services/mediaService'
import loggingService from '@/services/util/loggingService'
import loader from '@/components/Loader.vue'

export default {
    name: 'reconFormDocuments',
    components: {
        loader
    },
    data: function () {
        return {
            isDebug: false,
            mediaLoading: false,
            serverErrorList: [],
            mediaList: [],
            comment: '',
            mediaTypeId: '',
            mediaSubtypeId: '',
            filename: ''
        }
    },
    props: {
        reconForm: {}
    },
    watch: {
        reconForm: function () {
            this.loadData()
        }
    },
    computed: {
        docMediaTypes: function () {
            return [
                {
                    name: 'Shape File',
                    mediaTypeId: mediaService.mediaType.ReconForm
                },
                {
                    name: 'Images',
                    mediaTypeId: mediaService.mediaType.ReconFormImage
                },
                {
                    name: 'Supporting Documents',
                    mediaTypeId: mediaService.mediaType.ReconFormSupportDoc
                }
            ]
        }
    },
    mounted () {
        this.loadData()
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'Recon Form Documents', message)
        },
        loadMedia (mediaTypeId, mediaSubtypeId, parentId) {
            if (!parentId) {
                return Promise.resolve(1)
            }
            this.log('looking for parent: ' + parentId)
            return mediaService.list(this.$http, mediaTypeId, mediaSubtypeId, parentId).then(result => {
                this.mediaList = this.mediaList.concat(result.data)
                return result
            })
        },
        loadData () {
            this.mediaLoading = true
            var promises = []
            this.mediaList = []
            this.docMediaTypes.forEach(mediaType => {
                promises.push(this.loadMedia(mediaType.mediaTypeId, null, this.reconForm.buildingReconFormId))
            })
            Promise.all(promises).then(result2 => {
                this.log('After load, media list count: ' + this.mediaList.length)
                this.mediaLoading = false
            })
        },
        addFile () {
            this.$validator.validateAll('mediaFile').then(result => {
                this.log(`Validiting and Submitting File.`)
                if (result) {
                    var file = this.$refs['newFile'].files[0]
                    this.log(`Adding file. Type: ${this.mediaTypeId} Comment: ${this.comment} Name: ${file.name}`)
                    mediaService.putFile(this.$http, this.mediaTypeId, this.mediaSubtypeId, this.reconForm.buildingReconFormId, file, this.comment).then(result => {
                        this.resetFileUploadForm()
                        this.loadData()
                        this.errors.clear()
                    })
                } else {
                    this.log('Submit File - Invalid Form')
                }
            })
        },
        mediaDownloadRow (mediaId) {
            var mediaItem = this.mediaList.find(x => { return x.mediaId === mediaId })
            this.log(`mediaDownloadRow - mediaId: ${mediaItem.mediaId} , mediaTypeId: ${mediaItem.mediaTypeId}, parentId: ${mediaItem.parentId}`)
            mediaService.get(this.$http, mediaItem.mediaId, mediaItem.mediaTypeId, mediaItem.mediaSubtypeId, mediaItem.parentId).then(function (response) {
                mediaService.saveFileToDownload(response, mediaItem.filename)
            })
        },
        resetFileUploadForm () {
            this.mediaTypeId = ''
            this.comment = ''
            this.$refs['newFile'].value = null
        },
        mediaRemove (mediaId) {
            if (confirm('Are you sure you want to remove this file/document?')) {
                mediaService.removeByMediaId(this.$http, mediaId).then(result => {
                    this.loadData()
                })
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// ReconFormDocuments.vue?7f7be3d6